export default __webpack_public_path__ + "static/media/features.08b3a0d8.svg";